import { hasItems } from "utils/discovery";

const addSearchOccurrencesThemes = (state, nps) => {
  for (let i = 0; i < nps.length; i += 1) {
    const np = nps[i];
    const npIndex = state.themes.findIndex(
      (t) => t.GroupName === np.GroupName && np.NounPhrase === t.NounPhrase
    );

    if (npIndex !== -1) {
      state.themes[npIndex] = {
        ...state.themes[npIndex],
        Occurrences: np.Occurrences,
        FilteredByFilter: true,
        collapsed: false,
      };
    }
  }
};

const setDocFilterOcc = (group, state, themeIndex) =>
  state.themes[themeIndex].Documents.map((d) => ({
    ...d,
    Filter: {
      Occurrences:
        group.Documents.find((fd) => fd.Id === d.Id)?.Occurrences || 0,
    },
  }));

// We need to be careful with updating this function, as the performance of this
// function starts to become an issue the larger the data its processing
export const filterData = (state, action) => {
  const checkedNounPhrases = new Set();
  state.themes.forEach((theme) => {
    if (theme.NounPhrase && theme.checked) {
      checkedNounPhrases.add(theme.NounPhrase);
    }
  });

  const allThemesDocs = state.themes[0].Documents;
  const docOccurrencesMap = new Map();

  for (let i = 0; i < action.payload.length; i += 1) {
    const group = action.payload[i];

    docOccurrencesMap.clear();
    group.Documents.forEach((doc) => {
      docOccurrencesMap.set(doc.Id, doc.Occurrences);
    });

    for (let i = 0; i < allThemesDocs.length; i += 1) {
      if (!allThemesDocs[i].Filter) {
        allThemesDocs[i] = { ...allThemesDocs[i], Filter: { Occurrences: 0 } };
      }
      const docOccurrences = docOccurrencesMap.get(allThemesDocs[i].Id) || 0;
      allThemesDocs[i].Filter.Occurrences += docOccurrences;
    }

    // Add Search Occurrences to Theme
    const themeIndex = state.themes.findIndex(
      (t) => t.GroupName === group.GroupName && !t.NounPhrase
    );

    const theme = {
      ...state.themes[themeIndex],
      SearchOccurrences: group.Occurrences,
      FilteredByFilter: true,
      NounPhrases: group.NounPhrases,
      Documents: setDocFilterOcc(group, state, themeIndex),
    };

    // Add updated theme to theme list
    state.themes = state.themes
      .slice(0, themeIndex)
      .concat([theme])
      .concat(state.themes.slice(themeIndex + 1));

    // Update Noun Phrases
    if (hasItems(themeIndex, group.GroupName, state)) {
      addSearchOccurrencesThemes(state, group.NounPhrases);
    } else {
      const nps = group.NounPhrases.map((np) => {
        np.collapsed = false;
        np.FilteredByFilter = true;
        np.checked = checkedNounPhrases.has(np.NounPhrase);
        return np;
      });

      // Using splice on Redux state is not suggested, but the performance of splice is far better than using
      // slice in this situation. So if updating this, please test performance on large data sets  first
      state.themes.splice(themeIndex + 1, 0, ...nps);
    }
  }
};

export const removeFilteredByFilter = (state) => {
  state.themes = state.themes.map((theme) => ({
    ...theme,
    FilteredByFilter: false,
  }));
};

const removeFilterOccurrences = (state) => {
  state.themes = state.themes.map((theme) => ({
    ...theme,
    Documents: theme.Documents.map((document) => ({
      ...document,
      Filter: null,
    })),
  }));
};

const removeDisabledStateFromDocuments = (state) => {
  state.themes[0].Documents = state.themes[0].Documents.map((document) => ({
    ...document,
    disabled: false,
  }));
};

const removeAllThemesDocumentFilterResults = (state) => {
  const allThemesDocs = state.themes[0]?.Documents;

  for (let i = 0; i < allThemesDocs?.length; i += 1) {
    if (allThemesDocs[i].Search) {
      allThemesDocs[i] = { ...allThemesDocs[i], Search: undefined };
    }
  }
};

export const clearFilterState = (state) => {
  removeFilteredByFilter(state);
  removeFilterOccurrences(state);
  removeDisabledStateFromDocuments(state);
  removeAllThemesDocumentFilterResults(state);
};
